// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2wCs2","title":"FrontImage_title__3xLbX"};